const ELEMENT_NAME = "custom-subscription"; 

if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(
    ELEMENT_NAME,
    class extends HTMLElement {
      _isInit = false;
      _isInitListeners = false;
      connectedCallback() {
        if (this._isInit) return;
        if (this.querySelector('[name="selling_plan"]')) {
          this.initElement();
        } else {
          const observer = new MutationObserver((mutations) => {
            if (this.querySelector('[name="selling_plan"]')) {
              this.initElement();
              observer.disconnect();
            }
          });
          observer.observe(this, { childList: true, subtree: true });
        }
      }

      attributeChangedCallback(attribute, previousValue, currentValue) {
        if (attribute === "initialize" && previousValue === "false" && currentValue === "true") {
          setTimeout(() => {
            this._isInit = false;
            this.initElement();
          }, 500);
        }
      }

      static get observedAttributes() {
        return ["initialize"]
      }

      initElement() {
        if (this._isInit) return;

        const $subscribeOptionLabel = this.querySelector(".yotpo-radio-subscription-container .yotpo-radio-label-text");
        const $policyWrapper = this.querySelector(".yotpo-subscription-policy-wrapper");
        const $policyContainer = this.querySelector(".yotpo-subscription-policy-container");
        const $policyTextHeader = this.querySelector(".yotpo-subscription-policy-text-header");
        const $customTooltipTrigger = this.querySelector(".yotpo-widget-subscriptions-custom-tooltip-trigger");
        if ($subscribeOptionLabel && $policyWrapper && $policyContainer && !$customTooltipTrigger) {
          const $tooltipTrigger = document.createElement("div");
          $tooltipTrigger.classList.add("yotpo-widget-subscriptions-custom-tooltip-trigger");
          $subscribeOptionLabel.insertAdjacentElement("afterend", $tooltipTrigger);
          $tooltipTrigger.addEventListener("click", () => {
            $policyTextHeader.textContent = $subscribeOptionLabel.innerText.trim();
            $policyWrapper.classList.add("js-show");
          });

          const $policyClose = document.createElement("div");
          $policyClose.classList.add("yotpo-subscription-policy-container__close");
          $policyContainer.insertAdjacentElement("afterbegin", $policyClose);
          $policyClose.addEventListener("click", () => {
            $policyWrapper.classList.remove("js-show");
          });

          const $subscriptionStyle = document.createElement("style");
          const $styles =
            `
              .yotpo-radio-subscription-container .yotpo-subscription-label-price { --subscription-base-unit-price: '' }
              .yotpo-radio-subscription-container .yotpo-subscription-label-price::before { content: var(--subscription-base-unit-price, '') !important; }
            `;
          if ($subscriptionStyle.styleSheet) $subscriptionStyle.styleSheet.cssText = $styles;
          else $subscriptionStyle.appendChild(document.createTextNode($styles));
          $subscribeOptionLabel.insertAdjacentElement("afterend", $subscriptionStyle);
        }

        const $benefitsWrapper = this.querySelector(".yotpo-subscription-benefits-wrapper");
        const $subscriptionContainer = this.querySelector(".yotpo-radio-subscription-container");
        if ($benefitsWrapper && $subscriptionContainer) {
          $subscriptionContainer.insertAdjacentElement("beforeend", $benefitsWrapper);
        }

        const $prodPrice = document.querySelector(".product__price-and-rating > .product__price > .product__price--regular");
        let $prodPriceOriginal = convertValue($prodPrice.innerText);
        const $qtyInput = document.querySelector('.quantity-selector [name="quantity"]');
        const $prodPriceChart = document.querySelector(".product-price-chart");
        const $setQtyBtns = document.querySelectorAll(".product-price-chart [data-set-qty]");

        const $prdSelBtns = document.querySelectorAll(".product__selectors .radio__button .radio__input");
        if ($prdSelBtns.length) {
          $prdSelBtns.forEach(($btn) => {
            const $variantPriceOriginal = convertValue($btn.dataset.price);
            $btn.addEventListener("click", () => {
              $prodPriceOriginal = $variantPriceOriginal;
              $prodPriceChart.style.display = "block";
              $qtyInput.value = 1;
              if ($setQtyBtns.length) {
                $setQtyBtns.forEach(($btn) => {
                  const unitPrice = ($prodPriceOriginal - (($prodPriceOriginal * convertValue($btn.dataset.discount)) / 100)).toFixed(2).split('.');
                  $btn.querySelector("span > b").innerHTML = `$${unitPrice[0]}<sup>.${unitPrice[1]}</sup>`
                  $btn.classList.remove("is-active");
                });
              }
              this.setAttribute('initialize', this._isInit)
            });
            if ($btn.checked) $btn.click();
          }); 
        }

        const $planSelect = this.querySelector(".yotpo-selling-plan-select-container");
        const $sellingPlans = this.querySelectorAll('.yotpo-selling-plans .yotpo-radio-container [name="selling_plan"]');
        $sellingPlans.forEach(($plan) => {
          $plan.addEventListener("click", () => {
            const $planContainer = $plan.closest(".yotpo-radio-container");
            if ($planContainer.classList.contains("yotpo-radio-buy-once-container")) {
              $prodPriceChart.style.display = "block";
              $planSelect.classList.remove("js-show");
            }
            else {
              $prodPriceChart.style.display = "none";
              $planSelect.classList.add("js-show");
            }
            $qtyInput.value = 1;
            setTimeout(() => $qtyInput.dispatchEvent(new Event("change")), 500);
          });
        });

        const $planFrequencyOptions = this.querySelector(".yotpo-selling-plan-select-container .yotpo-frequency-options");
        const $planFrequencies = this.querySelectorAll(".yotpo-selling-plan-select-container .yotpo-frequency-options .yotpo-radio-and-dropdown-label");
        $planFrequencies.forEach(($item) => {
          const $itemText = $item.innerText;
          const $itemPrice = ($prodPriceOriginal - ($prodPriceOriginal * (parseFloat($itemText.substr($itemText.indexOf("(") + 1).replace("% off)", "")) / 100))).toFixed(2);
          $item.dataset.price = $itemPrice;
          $item.addEventListener("click", () => {
            $planFrequencyOptions.dataset.frequencyPriceSelected = $item.dataset.price;
            setTimeout(() => $qtyInput.dispatchEvent(new Event("change")), 500);
          });
        });

        let maxQty;

        if (this._isInitListeners === false) maxQty = 0;

        function convertValue(value) {
          let newValue = value.replace(/[^0-9.-]+/g, "");
          return parseFloat(newValue);
        }

        function updateActiveQtyBtn() {
          const qty = +$qtyInput.value;
          $setQtyBtns.forEach(($btn) => {
            const btnQty = +$btn.getAttribute("data-set-qty");
            const isActive = btnQty === (qty > maxQty ? maxQty : qty);
            $btn.classList.toggle("is-active", isActive);
          });

          let newPrice = "";

          if ($prodPriceChart.style.display === "block") {
            let unitPrice = "";
            if (qty == 1) newPrice = unitPrice = "$" + $prodPriceOriginal.toFixed(2);
            else {
              const $planPrice = document.querySelector(".product-price-chart [data-set-qty].is-active span > b");
              unitPrice = $planPrice.innerText;
              newPrice = `<span class="product__price--unit">${qty} x ${unitPrice}</span><br />${(convertValue(unitPrice) * qty).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`;
            }
            document.querySelector(".yotpo-radio-buy-once-container .yotpo-subscription-label-price").innerText = unitPrice;
          }
          else {
            let $planPrice = 0;
            if ($planFrequencyOptions.hasAttribute("data-frequency-price-selected")) $planPrice = convertValue($planFrequencyOptions.dataset.frequencyPriceSelected);
            else {
              const $planFrequency = document.querySelector(".yotpo-selling-plan-select-container .yotpo-frequency-options .yotpo-radio-and-dropdown-option:checked + .yotpo-radio-and-dropdown-label");
              $planPrice = convertValue($planFrequency.dataset.price);
              var $oneTimeSelected = document.querySelector(".yotpo-radio-label-input.yotpo-selling-plan-radio-label");
              if ($oneTimeSelected && $oneTimeSelected.hasAttribute("data-selling-plan-name") && $oneTimeSelected.dataset.sellingPlanName == "One-time purchase" && $oneTimeSelected.checked) {
                  $planPrice = $prodPriceOriginal;
                  if (qty > 1) {
                    var $selectedQuantity = document.querySelector('.product-price-chart .is-active');
                    if ($selectedQuantity) {
                      $planPrice = ($prodPriceOriginal - (($prodPriceOriginal * convertValue($selectedQuantity.dataset.discount)) / 100));
                      document.querySelector(".yotpo-radio-buy-once-container .yotpo-subscription-label-price").innerText = "$" + $planPrice.toFixed(2);
                    }
                  }
              }
            }
            if (qty == 1) newPrice = "$" + $planPrice.toFixed(2);
            else newPrice = `<span class="product__price--unit">${qty} x ${$planPrice.toFixed(2)}</span><br />${($planPrice * qty).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`;
          }
          document.querySelector(".yotpo-radio-subscription-container .yotpo-subscription-label-price").style.setProperty("--subscription-base-unit-price", `'$${$prodPriceOriginal.toFixed(2)}'`)
          $prodPrice.innerHTML = newPrice;
        }
        updateActiveQtyBtn();

        if (this._isInitListeners === false) {
          $qtyInput.addEventListener("change", updateActiveQtyBtn);

          $setQtyBtns.forEach(($btn) => {
            const btnQty = +$btn.getAttribute("data-set-qty");
            if (btnQty > maxQty) maxQty = btnQty;
            $btn.addEventListener("click", () => {
              let newQty = 1;
              if (!$btn.classList.contains("is-active")) {
                newQty = btnQty;
                newQty = !isNaN(newQty) ? newQty : 1;
              }
              $qtyInput.value = newQty;
              setTimeout(() => $qtyInput.dispatchEvent(new Event("change")), 500);
            });
          });

          const $qtyBtns = document.querySelectorAll(".quantity-selector .quantity__btn");
          $qtyBtns.forEach(($btn) => {
            $btn.addEventListener("click", () => setTimeout(() => $qtyInput.dispatchEvent(new Event("change")), 500));
          });
        }

        this._isInit = true;
        this._isInitListeners = true;
      }
    }
  );
}
